import { useTranslation } from 'react-i18next';
import { Button, Typography } from 'mobily-ui-library/lib';

import './StickyPriceBar.scss';

interface Props {
    rtl: boolean;
    orderPriceData: any
    handleCheckout: () => void
    checkOutOfStock: boolean
}

function StickyPriceBar({ rtl, orderPriceData, handleCheckout, checkOutOfStock }: Props) {
    const { t } = useTranslation();

    return (
        <div className={rtl ? 'CartPage__StickyPriceBar CPSB__Right' : 'CartPage__StickyPriceBar'}>
            <div className='SPB__Container'>
                <div className='SPB__PriceButton'>
                    <div className='SPB__Total'>
                        <Typography rtl={rtl} className='SPB__CartText'>{t("Cart_total")}</Typography>
                        <Typography rtl={rtl} className='SPB__Price'>
                            <span>{t("SAR")}&nbsp;</span>
                            {orderPriceData?.cartTotalPrice?.[0].price?.taxIncludedAlteredAmount?.value} 
                        </Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className='SPB__Button'
                        onClick={handleCheckout}
                        variant={checkOutOfStock ? 'disabled' : 'default'}
                    >
                        {t("Checkout")}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default StickyPriceBar;